import { ReactElement, ReactNode, createContext, useState } from 'react';

import { Toast, ToastProps } from '@/common/components/Toast/Toast';
import { TOAST_ANIMATION_DURATION } from '@/common/components/Toast/Toast.const';

const ToastContext = createContext<ToastContextProps>({
  displayToast: () => {
    return;
  },
});
export default ToastContext;

export interface ToastContextProps {
  displayToast: (toast: ToastProps) => void;
}

interface ToastDataWithId extends ToastProps {
  id: string;
}

const ToastContextProvider = ({ children }: { children: ReactNode }): ReactElement => {
  const [toasts, setToasts] = useState<ToastDataWithId[]>([]);

  const addToast = (toast: ToastProps) => {
    const toastId = `toast-${Date.now()}`;
    setToasts((currentToasts) => [...currentToasts, { ...toast, id: toastId }]);
    setTimeout(
      () => setToasts((currentToasts) => currentToasts.slice(1)),
      TOAST_ANIMATION_DURATION,
    );
  };

  return (
    <ToastContext.Provider value={{ displayToast: addToast }}>
      {children}
      {toasts.map((toast: ToastDataWithId) => (
        <Toast key={toast.id} type={toast.type}>
          {toast.children}
        </Toast>
      ))}
    </ToastContext.Provider>
  );
};

export { ToastContextProvider };
